<template>
  <v-layout>
    <v-flex xs12>
      <child-toolbar :title="title" :buttons="buttons" />
      <bt-realization-expense-form @input="change" v-model="editExpense" v-if="loaded" ref="form" :editable="editable" />
      <h2 v-else>Loading...</h2>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import BtRealizationExpenseForm from './BtRealizationExpenseForm'
import ChildToolbar from '@/components/ChildToolbar'
import _ from 'lodash'

const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'BtRealizationExpenseDetail',
  components: {
    BtRealizationExpenseForm,
    ChildToolbar
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    backRoute: {
      type: [String, Object],
      required: false,
      default: null
    },
    expense: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      title: 'Expense Realization',
      buttons: [
        { tooltip: 'Close',
          icon: 'close',
          handler: this.close
        },
        { tooltip: 'Save',
          icon: 'save',
          handler: this.save,
          disabled: !this.formValid,
          render: this.editable
        }
      ],
      formValid: false,
      modified: false,
      loaded: false,
      editExpense: {}
    }
  },
  watch: {
    formValid (newValue) {
      this.buttons.find(x => x.handler === this.save).disabled = !newValue
    }
  },
  methods: {
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      this.editExpense = _.cloneDeep(this.expense)
      this.editExpense.documentState = this.value.documentState
      this.loaded = true
    },
    save () {
      const self = this

      self.editExpense.subTotal = parseFloat(self.editExpense.subTotal)
      self.editExpense.total = parseFloat(self.editExpense.total)
      self.editExpense.percentage = parseFloat(self.editExpense.percentage)
      // existing expense, set tag to update
      if (self.editExpense._tag.status !== 'new') {
        self.editExpense._tag.status = 'update'
      }

      self.$set(self.value.expenses, self.index, self.editExpense)
      self.$success('Realization Expense updated')
      self.modified = false
      self.$emit('updateExpense', self.value.expenses)
      self.close()
    },
    close () {
      this.$router.replace(this.backRoute)
    },
    change () {
      this.formValid = this.$refs.form.validate()
      this.modified = true
    }
  },
  mounted () {
    if (!this.loaded) {
      this.loadResources()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  },
  beforeRouteLeave (to, from, next) {
    if (this.modified) {
      const yesHandler = () => {
        this.closeConfirmation()
        next()
      }

      const noHandler = () => {
        this.closeConfirmation()
      }

      this.showConfirmation({
        message: 'Are you sure?',
        title: 'This Business Trip Expense Realization will not saved.',
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationExpenseDetail.vue